import {getData, postData, postDataWithSession, postMultipartData} from '.';

import { API_URL } from '../config';
import {API_ENDPOINTS} from "../constants";
import {json} from "react-router-dom";

export const requestSession = async (username, body) => {
  const params = new URLSearchParams({
    userName: username,
  });

  const formData = new FormData();

  formData.append('pCode', body.pCode);

  const options = {
    body: formData
  };

  try {
    const data = await postMultipartData(`${API_URL}/auth/authUser?${params}`, options);
    const { id } = data;

    return { session: id, user: data };
  } catch (error) {
    return Promise.reject (error.cause);
  }
};

export const endSession = async (username) => {
  const params = new URLSearchParams({
    userName: username,
  });

  try {
    const data = await postData(`${API_URL}/auth/logout?${params}`, );

    return true;
  } catch (error) {
    return error;
  }
}

export const getSessionFromLocalStorage = () => {
  const user = localStorage.getItem('user');
  const userComposite = localStorage.getItem('userComposite');
  const session = localStorage.getItem('session');
  const sessionExpireDate = localStorage.getItem('sessionExpireDate');

  if (!(user && session)) {
    return {};
  }

  return { user, userComposite, session, sessionExpireDate};
};

export const storeSessionInLocalStorage = (username, userComposite, session) => {
  localStorage.setItem('user', username);
  localStorage.setItem('userComposite', userComposite);
  localStorage.setItem('session', session);
};

export const storeSessionExpireDateInLocalStorage = (sessionExpireDate) => {
  localStorage.setItem('sessionExpireDate', sessionExpireDate);
}

export const clearSessionInLocalStorage = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('userComposite');
  localStorage.removeItem('session');
  localStorage.removeItem('sessionExpireDate');
  localStorage.removeItem('currentDistrict');
  localStorage.removeItem('permissionsList');
};

export const forgotPwd = async (email) => {
  const params = new URLSearchParams({
    emailAddress: email
  });

  return await postData(`${API_URL}/auth/forgotPwd?${params}`, {});
}

export const acceptTerms = async (user) => {
  const options = {
    body: JSON.stringify(user)
  };

  try {
    return await postData(`${API_URL}/${API_ENDPOINTS.ACCEPT_TERMS}`, options);
  } catch (error) {
    return error;
  }
}

export const updatePassword = async (queryParams, body) => {
  const postQueryParams = new URLSearchParams(queryParams);

  const formData = new FormData();

  formData.append("pwd", body.pwd);

  const options = {
    body: formData
  }

  return postMultipartData(`${API_URL}/${API_ENDPOINTS.UPDATE_PASSWORD}?${postQueryParams}`, options, true);
}

export const changePwd = async (queryParams, body) => {
  const postQueryParams = new URLSearchParams(queryParams);

  const formData = new FormData();
  formData.append("currentPwd", body.currentPwd);
  formData.append("newPwd", body.newPwd);

  const options = {
    body: formData
  };

  return postMultipartData(`${API_URL}/${API_ENDPOINTS.CHANGE_PASSWORD}?${postQueryParams}`, options);
}

export const getTimeOut = async (queryParams) => {
  return postDataWithSession(queryParams, `${API_URL}/${API_ENDPOINTS.GET_TIME_OUT}`, {});
}
